/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Stack } from "@mybridge/ui/layout";
import { Link } from "@mybridge/ui/link";
import { SeeMore } from "@mybridge/ui/see-more";
import { Spinner } from "@mybridge/ui/spinner";
import { useContext, useState } from "react";
import { PostCommentRowContext } from "../context";
import { MediaDisplay } from "../media-display";
import { Skeleton } from "@mybridge/ui/skeleton";
import { escapeHtml } from "v4/utils/utils";

// eslint-disable-next-line no-empty-pattern
export const PostCommentRowBody = ({...props}) => {
    const { comment, hasMedia, commentOwner } = useContext(PostCommentRowContext);
    const { body } = comment ?? {};

    const [mediaLoaded, setMediaLoaded] = useState(false);

    const convertToLinks = (text) => {
        if (!text) return '';
        const escaped = escapeHtml(text);
        const regex = /\{\{(.*?)\}\}/g;
        const parts = [];
        let lastIndex = 0;
        
        // text?.replace(regex, (match, p1, offset) => {
        //     parts.push(text.substring(lastIndex, offset));
        //     parts.push(`<a href="/p/${commentOwner?.slug || props?.commentOwner?.slug}" target="_blank" rel="noopener noreferrer" style="color:#488FEC; font-weight:600">${p1}</a>`);
        //     lastIndex = offset + match.length;
        // });
        // parts.push(text?.substring(lastIndex));
        escaped?.replace(regex, (match, p1, offset) => {
            parts.push(escaped.substring(lastIndex, offset));
            parts.push(`<a href="/p/${commentOwner?.slug || props?.commentOwner?.slug}" target="_blank" rel="noopener noreferrer" style="color:#488FEC; font-weight:600">${p1}</a>`);
            lastIndex = offset + match.length;
        });

        parts.push(escaped?.substring(lastIndex));

        return parts.join('');
    };
    
    
    return <>
        {body?.length && body !== "‏‏‎ ‎" ? (
            <SeeMore
                color="brandGray.700"
                px={4}
                py={2}
                isInline={true}
                maxLength={350}
                html={convertToLinks(body)}
                fontSize="md"
            />
        ) : (
            <></>
        )}
        <Box minH={(hasMedia && !mediaLoaded) ? "300px" : "0"} pos="relative">
            {hasMedia && !mediaLoaded ?
                <Skeleton
                    pos="absolute"
                    left="0"
                    right="0"
                    top="0"
                    bottom="0"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Spinner />
                </Skeleton> : ""}
            <MediaDisplay onLoaded={() => setMediaLoaded(true)} />
        </Box>
    </>
}